export const projects=[
        {
            maincategory:"_",
            subcategory:"Machine Learning",
            title:"Heart Failure Prediction",
            description:"By using machine learning ,predicting wheather from symtoms and follow up days of from the treatment can a person be saved or not",
            gitlink:"https://github.com/SPARSHpathak2002/Machine_Learning/blob/main/Heart_Failure_Prediction.ipynb",
            weblink:"NA"
        },
        {
            maincategory:"_",
            subcategory:"React",
            title:"Shopping Cart API",
            description:"This is a basic shopping cart application created as part of practice for react,redux and API's in React.js . As a part of Items  'Memes' are used which a user can buy",
            gitlink:"https://github.com/SPARSHpathak2002/React_mini_projects/tree/main/Shopping_cart",
            weblink:"https://wondrous-quokka-914331.netlify.app/"
        },
        {
            maincategory:"_",
            subcategory:"React",
            title:"Sorting Algorithm Visualizer",
            description:"It analyses various sorting algorithms and accurately simulates data.",
            gitlink:"https://github.com/SPARSHpathak2002/React_mini_projects/tree/main/AlgorithmVisulizer",
            weblink:"https://sortalgoviz.netlify.app/"
        },
        {
            maincategory:"react",
            subcategory:"React",
            title:"Sorting Algorithm Visualizer",
            description:"It analyses various sorting algorithms and accurately simulates data.",
            gitlink:"https://github.com/SPARSHpathak2002/React_mini_projects/tree/main/AlgorithmVisulizer",
            weblink:"https://sortalgoviz.netlify.app/"
        },
        {
            maincategory:"react",
            subcategory:"React",
            title:"Persnol Portfolio",
            description:"Designing Persnol Portfolio with react and deploying it with continues features updates ",
            gitlink:"https://github.com/SPARSHpathak2002/MyPortfolio",
            weblink:"https://persnolportfolio.netlify.app/"
        },
        {
            maincategory:"_",
            subcategory:"React",
            title:"Persnol Portfolio",
            description:"Designing Persnol Portfolio with react and deploying it with continues features updates ",
            gitlink:"https://github.com/SPARSHpathak2002/MyPortfolio",
            weblink:"https://persnolportfolio.netlify.app/"
        },
        {
            maincategory:"react",
            subcategory:"React",
            title:"Shopping Cart API",
            description:"This is a basic shopping cart application created as part of practice for react,redux and API's in React.js . As a part of Items  'Memes' are used which a user can buy",
            gitlink:"https://github.com/SPARSHpathak2002/React_mini_projects/tree/main/Shopping_cart",
            weblink:"https://wondrous-quokka-914331.netlify.app/"
        },
        {
            maincategory:"react",
            subcategory:"React",
            title:"Diacom Viewer",
            description:"React based web Application for viewing DIACOM images",
            gitlink:"https://github.com/SPARSHpathak2002/Diacom_viewer",
            weblink:"NA"
        },
        {
            maincategory:"ML",
            subcategory:"Machine Learning",
            title:"Heart Failure Prediction",
            description:"By using machine learning ,predicting wheather from symtoms and follow up days of from the treatment can a person be saved or not",
            gitlink:"https://github.com/SPARSHpathak2002/Machine_Learning/blob/main/Heart_Failure_Prediction.ipynb",
            weblink:"NA"
        }
       
]
